let SupportLinksData = [{
    "title": "Help",
    "route": "help"
}, {
    "title": "Contact",
    "route": "contact"
}]

export default SupportLinksData